import appConfig from '@/features/app/constants/app-config';
import legacy_parseAndValidateAccessToken from '@/features/auth/functions/legacy_parseAndValidateAccessToken';
import { _unixToClientTime } from '@/shared/functions/timezone';
import Cookies from 'js-cookie';

export default function getRefreshTokenExpiryTime(
  useCookieStorage: boolean,
  enableLegacyTokenStorage: boolean
) {
  if (useCookieStorage) {
    const refreshTokenExpireDate = Cookies.get(appConfig.refreshTokenExpireDateKey);
    if (refreshTokenExpireDate) {
      const expiryTime = _unixToClientTime(parseInt(refreshTokenExpireDate));
      return expiryTime;
    }
  }

  if (enableLegacyTokenStorage) {
    const cookie = Cookies.get(appConfig.authTokenKey);
    if (!cookie) return null;
    const token = legacy_parseAndValidateAccessToken(cookie);
    if (!token) return null;
    return _unixToClientTime(token.refreshTokenExpiresAt ?? token.expiresAt);
  }

  return null;
}
